import router from '@/router/router';

// eslint-disable-next-line

var permission = {
  state: {
    routers: router,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: function SET_ROUTERS(state, routers) {
      state.addRouters = routers;
      state.routers = routers;
    }
  },
  actions: {
    GenerateRoutes: function GenerateRoutes(_ref, data) {
      var commit = _ref.commit;
      return new Promise(function (resolve) {
        commit('SET_ROUTERS', router);
        resolve();
      });
    }
  }
};
export default permission;